export default {
  feedback: {
    reasons: "Sebepler",
    reason: "Sebep",
    feeling: "Yüz ifadesi",
    feeling_enum: {
      BAD: "Çok Kötü",
      SAD: "Kötü",
      NORMAL: "Normal",
      HAPPY: "Mutlu",
      ECSTATIC: "Çok Mutlu"
    },
    title: "Geri Bildirim {0} / {1}",
    comment: "Açıklama"
  }
};
